import React from 'react';
import {FadeIn} from './ui/FadeIn';

const steps=[
  {num: "01",title: "The Conversation",desc: "Every engagement, even the 60-minute call, starts with a free 30-minute conversation. We talk about what you're trying to do, whether I can help, and whether we'd actually enjoy working together. If either answer is no, I'll tell you."},
  {num: "02",title: "The Brief",desc: "If we move forward, I send a one-page brief within 48 hours: what we're working on, how we'll measure it, and what you can expect from me. Nothing starts without your sign-off."},
  {num: "03",title: "The Work",desc: "This is the part most consultants skip. I write every word myself. I build every list by hand or with tools I've vetted personally. I don't outsource, I don't subcontract, and I don't use ChatGPT to fill pages."},
  {num: "04",title: "The Handover",desc: "You get documentation you can actually use, written in plain English, not in consultant speak. If we've built a system, you own it completely. If we've written a strategy, it's short enough to read in one sitting."}
];

export function Process() {
  return (
    <section id="process" className="py-section-mob md:py-section-desk bg-fog">
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk">
        <FadeIn>
          <h2 className="font-heading text-h2-mob md:text-h2-desk text-ink mb-16 md:mb-24"> How any engagement runs </h2>
        </FadeIn>
        <div className="relative border-l border-hairline ml-4 md:ml-8">
          <div className="space-y-[80px]">
            {steps.map((step,idx)=> (
              <FadeIn key={idx} delay={idx * 0.1} className="relative pl-10 md:pl-16">
                <div className="absolute left-0 top-6 w-6 h-[1px] bg-hairline -translate-x-full"></div>
                <div className="flex flex-col md:flex-row md:items-baseline gap-4 md:gap-12">
                  <span className="font-heading text-[56px] leading-none text-graphite/40 w-20 shrink-0"> {step.num}. </span>
                  <div>
                    <h3 className="font-heading text-h3-desk text-ink mb-3"> {step.title} </h3>
                    <p className="font-body text-[17px] text-ink leading-relaxed max-w-prose-block"> {step.desc} </p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}